<app-layout>
  <div class="row">
    <div class="col-lg-6 col-md-12 offset-lg-3 mt-3 mr-3">
      <div class="card">
        <div class="card-status-top bg-success"></div>
        <div class="card-body">
          <h3 class="card-title">Kayıt başarıyla oluşturuldu.</h3>
          <div class="text-blue clickable" (click)="goToLojistik()">Lojistik Sayfasına Git</div>
          <br>
          <div class="text-green clickable" (click)="newLojistik()">Yeni kayıt oluştur</div>
        </div>
      </div>
    </div>
  </div>
  </app-layout>
  